import script from "./ContactUsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactUsPage.vue?vue&type=script&setup=true&lang=js"

import "./ContactUsPage.vue?vue&type=style&index=0&id=6ed9f563&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ed9f563"]])

export default __exports__